/** 로그인 직후 1회: LS가 있어도 서버에서 다시 받아 캐시를 갱신한다(세션 메모리만, LS 아님). */

const pendingWorkspaceIds = new Set<string>();

export function markPostLoginSchoolDataNetworkRefresh(workspaceId: string): void {
  const id = workspaceId.trim();
  if (id) pendingWorkspaceIds.add(id);
}

/** true면 이번 ensure/fetch에서 forceRefresh를 켜야 한다(워크스페이스당 1회 소비). */
export function consumePostLoginSchoolDataNetworkRefresh(workspaceId: string): boolean {
  const id = workspaceId.trim();
  if (!id || !pendingWorkspaceIds.has(id)) return false;
  pendingWorkspaceIds.delete(id);
  return true;
}

export function clearPostLoginSchoolDataNetworkRefresh(workspaceId?: string): void {
  if (workspaceId?.trim()) {
    pendingWorkspaceIds.delete(workspaceId.trim());
    return;
  }
  pendingWorkspaceIds.clear();
}
